export function ContentChecker (pEditor)
{
  const reAnchors = new RegExp('usercustomanchor', 'i');

  let isStopCheckContentChanged = false,
      currentEditorContent,
      excludeWordCheck = false,
      excludeWordCheckTM = null,
      minCharsForStartTidy = 300,
      oldContentLength,
      newContentLength,
      isPasteEvent = 0,
      numberOfP = 0,
      afterClearCallBack = null;


  this.checkContentChanged = () =>
  {
    if (isStopCheckContentChanged)
    {
      return;
    }

    if (numberOfP !== pEditor.iFrameDoc.body.getElementsByTagName('P').length)
    {
      pEditor.contentCleaner.removeEmptyP();
      numberOfP = pEditor.iFrameDoc.body.getElementsByTagName('P').length;
    }

    if (BEditor.browser.isIE)
    {
      pEditor.helpers.fixers.fixIELastLine();

      if (pEditor.iFrameDoc.body.innerHTML.length !== newContentLength)
      {
        oldContentLength = currentEditorContent.length;
        currentEditorContent = pEditor.iFrameDoc.body.innerHTML;
        newContentLength = currentEditorContent.length;
        return;
      }
    }

    if (pEditor.iFrameDoc.body.innerHTML !== currentEditorContent)
    {
      oldContentLength = currentEditorContent.length;
      currentEditorContent = pEditor.iFrameDoc.body.innerHTML;
      newContentLength = currentEditorContent.length;

      if (reAnchors.test(currentEditorContent))
      {
        pEditor.anchor.reCollectAnchors();
      }

      if (!excludeWordCheck)
      {
        confirmClearMsHTML(setContentAfterClearMsHTML, currentEditorContent);
      }
      else
      {
        if (!pEditor.undoRedo.isUndoRedoExecuted)
        {
          pEditor.undoRedo.saveUndo();
        }

        pEditor.undoRedo.isUndoRedoExecuted = false;
      }

      pEditor.layer.objectFactory.fixAllAbsElements();
      pEditor.image.objectFactory.checkAllImages();
    }

    clearExcludeWordCheck();
  };


  function setExcludeWordCheck ()
  {
    if (excludeWordCheckTM) clearTimeout(excludeWordCheckTM);
    excludeWordCheck = true;
  }

  
  function clearExcludeWordCheck ()
  {
    if (excludeWordCheckTM) clearTimeout(excludeWordCheckTM);
    excludeWordCheckTM = setTimeout(clearExcludeWordCheckDo, 737);
  }

  
  function clearExcludeWordCheckDo ()
  {
    if (excludeWordCheckTM) clearTimeout(excludeWordCheckTM);
    excludeWordCheck = false;
  }


  this.onPasteHandler = (callBack) =>
  {
    if (pEditor.iFrameDoc.body.innerHTML !== currentEditorContent)
    {
      oldContentLength = currentEditorContent.length;
      currentEditorContent = pEditor.iFrameDoc.body.innerHTML;
      newContentLength = currentEditorContent.length;
    }

    if (reAnchors.test(currentEditorContent))
    {
      pEditor.anchor.reCollectAnchors();
    }

    isPasteEvent = 2;

    if (callBack)
    {
      afterClearCallBack = callBack;
    }

    confirmClearMsHTML(setContentAfterClearMsHTML, currentEditorContent);

    pEditor.layer.objectFactory.fixAllAbsElements();
    pEditor.image.objectFactory.checkAllImages();
    pEditor.helpers.fixers.fixGeckoAlign();

    pEditor.undoRedo.saveUndoDo(false, null, false, true);
  };


  this.onCutHandler = () =>
  {
    if (pEditor.iFrameDoc.body.innerHTML !== currentEditorContent)
    {
      oldContentLength = currentEditorContent.length;
      currentEditorContent = pEditor.iFrameDoc.body.innerHTML;
      newContentLength = currentEditorContent.length;
    }

    pEditor.undoRedo.saveUndo();
    pEditor.undoRedo.isUndoRedoExecuted = false;
  };


  function setContentAfterClearMsHTML (contentHTML, isChanged)
  {
    if (contentHTML != null && isChanged)
    {
      setExcludeWordCheck();

      currentEditorContent = contentHTML;
      pEditor.iFrameDoc.body.innerHTML = currentEditorContent;

      pEditor.anchor.reCollectAnchors();
      pEditor.image.objectFactory.checkAllImages();

      BEditor.EditorsManager.hidePageShadingContainer();

      if (typeof(afterClearCallBack) === 'function')
      {
        afterClearCallBack();
        afterClearCallBack = null;
      }
    }
    else
    {
      confirmCallTidyServices(contentHTML);
    }

    if ((BEditor.browser.isIE || !pEditor.undoRedo.isUndoRedoExecuted) && !isPasteEvent)
    {
      pEditor.undoRedo.saveUndo();
    }

    isPasteEvent--;
    pEditor.undoRedo.isUndoRedoExecuted = false;
  }


  function confirmClearMsHTML (callBackMethod, contentHTML, isRawHtml)
  {
    const isMsHTMLInContent = pEditor.style.normalizer.checkMsHTML(contentHTML);

    if (isMsHTMLInContent)
    {
      BEditor.EditorsManager.showPageShadingContainer(true, 'Cleaning HTML...', 1000);
      setExcludeWordCheck();
      setTimeout(function() { startClearMsHTML(callBackMethod, contentHTML, isRawHtml, true); }, 333);
    }
    else
    {
      callBackMethod(contentHTML, false);
    }
  }


  function startClearMsHTML (callBackMethod, contentHTML, isRawHtml, isTidyValidate)
  {
    if (!isRawHtml)
    {
      contentHTML = pEditor.helpers.userJavascript.restore(contentHTML);
      contentHTML = pEditor.anchor.restoreAnchors(contentHTML);
    }

    contentHTML = pEditor.style.normalizer.clearMsHTML(contentHTML);
    (pEditor.isTidyServiceOn && isTidyValidate) ? callTidyServices(callBackMethod, contentHTML) : endClearMsHTML(callBackMethod, contentHTML);
  }


  function confirmCallTidyServices (contentHTML)
  {
    if (pEditor.isTidyServiceOn && (newContentLength - oldContentLength > minCharsForStartTidy || (isPasteEvent && Math.abs(newContentLength - oldContentLength) > minCharsForStartTidy)) && newContentLength < (newContentLength - oldContentLength) * 500)
    {
      BEditor.EditorsManager.showPageShadingContainer(true, 'Cleaning HTML...', 1000);
      setExcludeWordCheck();
      callTidyServices(setContentAfterClearMsHTML, contentHTML, true);
    }
    else
    {
      BEditor.EditorsManager.hidePageShadingContainer();

      if (typeof(afterClearCallBack) === 'function')
      {
        afterClearCallBack();
        afterClearCallBack = null;
      }
    }
  }


  function callTidyServices (callBackMethod, contentHTML, isProcessedHtml)
  {
    if (isProcessedHtml)
    {
      contentHTML = pEditor.helpers.userJavascript.restore(contentHTML);
      contentHTML = pEditor.anchor.restoreAnchors(contentHTML);
      contentHTML = pEditor.style.normalizer.clearMsHTML(contentHTML);
    }

    pEditor.repairAndCleanHtml(contentHTML, function (contentHTML) { endClearMsHTML(callBackMethod, contentHTML); });
  }


  function endClearMsHTML (callBackMethod, contentHTML)
  {
    if (contentHTML != null)
    {
      contentHTML = pEditor.helpers.userJavascript.collect(contentHTML);
      contentHTML = pEditor.anchor.collectAnchors(contentHTML);
    }

    callBackMethod(contentHTML, true);
  }


  this.setExcludeWordCheck = setExcludeWordCheck;
  this.clearExcludeWordCheckDo = clearExcludeWordCheckDo;
  this.confirmClearMsHTML = confirmClearMsHTML;

  Object.defineProperty(this, 'reAnchors', { get: () => reAnchors});
  Object.defineProperty(this, 'isStopCheckContentChanged', { get: () => isStopCheckContentChanged, set: v => { isStopCheckContentChanged = v }});
  Object.defineProperty(this, 'currentEditorContent', { get: () => currentEditorContent, set: v => { currentEditorContent = v }});
  Object.defineProperty(this, 'oldContentLength', { get: () => oldContentLength, set: v => { oldContentLength = v }});
  Object.defineProperty(this, 'isPasteEvent', { get: () => isPasteEvent, set: v => { isPasteEvent = v }});
  Object.defineProperty(this, 'afterClearCallBack', { get: () => afterClearCallBack, set: v => { afterClearCallBack = v }});
}